/**
 * ExPay panel yardımcıları.
 *
 * Ayarlar `settings` kaydında **değildir** — `provider_configs` satırında tek
 * bir JSON gövdesidir (bkz. backend/services/expay.py). Özel anahtar
 * (`private_key`) sunucudan geri dönmez; boş bırakılırsa gönderilmez, yani
 * kayıtlı değer korunur. `public_key` bilinçli olarak sır değildir: her
 * isteğin başlığında açıkça gider ve yönetici onu sağlayıcı panelindekiyle
 * karşılaştırabilmelidir.
 */

export const EXPAY_DEFAULTS = {
  enabled: false,
  api_url: 'https://apiv2.expay.cash',
  public_key: '',
  private_key: '',
  merchant_id: 'main',
  deposit_flow: 'h2h',
  callback_url: '',
  return_url: '',
  balance_token: 'USDTTRC',
  deposit_enabled: true,
  withdraw_enabled: true,
  deposit_min_amount: 100,
  deposit_max_amount: 50000,
  withdraw_min_amount: 100,
  withdraw_max_amount: 50000,
};

export const CALLBACK_PATH = '/api/expay/callback';

export const DEPOSIT_FLOWS = [
  {
    value: 'h2h',
    label: 'Hesap bilgisi ekranda (H2H)',
    hint: 'İşleme atanan IBAN ve alıcı adı oyuncunun yatırım ekranında gösterilir.',
  },
  {
    value: 'p2p_payform',
    label: 'ExPay ödeme sayfası',
    hint: 'Oyuncu ExPay\'in ödeme sayfasına yönlendirilir, ödeme sonrası siteye döner.',
  },
];

const SECRET_KEYS = ['private_key'];

// Adresleri biz üretiriz, yönetici yazmaz: ikisi de kaydedilirken güncel site
// kökünden türetilir (bkz. CLAUDE.md → *Alan adı değişince adresler geride
// kalır*).
const DERIVED_KEYS = ['callback_url', 'return_url'];

const sameValue = (a, b) => {
  if (typeof a === 'boolean' || typeof b === 'boolean') {
    return Boolean(a) === Boolean(b);
  }
  if (typeof a === 'number' || typeof b === 'number') {
    const left = Number(a ?? 0);
    const right = Number(b ?? 0);
    if (Number.isFinite(left) && Number.isFinite(right)) return left === right;
  }
  return String(a ?? '') === String(b ?? '');
};

/**
 * Sunucuya gönderilecek gövde: yalnızca değişen alanlar. Bildirim ve dönüş
 * adresleri salt okunurdur; kayıttaki değer geride kalmışsa kaydedilirken
 * düzeltilir. Bildirim adresi **her istekte** sağlayıcıya gönderildiği için
 * geride kalmış bir değer, bildirimi var olmayan bir alan adına yollatırdı.
 */
export const changedFields = (current, initial, options = {}) => {
  const { paymentBase = '', siteBase = '' } = options;
  const values = current || {};
  const saved = initial || {};
  const payload = {};
  Object.keys(EXPAY_DEFAULTS).forEach((key) => {
    if (DERIVED_KEYS.includes(key)) return;
    const next = values[key];
    if (next === undefined) return;
    if (SECRET_KEYS.includes(key)) {
      if (String(next || '').trim()) payload[key] = String(next).trim();
      return;
    }
    if (!sameValue(next, saved[key])) payload[key] = next;
  });
  if (paymentBase) {
    const url = `${paymentBase}${CALLBACK_PATH}`;
    if (!sameValue(saved.callback_url, url)) payload.callback_url = url;
  }
  // Dönüş adresi oyuncunun tarayıcısına verilir, bu yüzden adres defterine
  // değil **yaşayan siteye** bağlanır.
  if (siteBase) {
    const url = `${siteBase}/hesap/para-yatir`;
    if (!sameValue(saved.return_url, url)) payload.return_url = url;
  }
  return payload;
};
